import { Sparkle, CloseIcon, ExpandIcon, CollapseIcon } from './Sparkle';

export interface HeaderProps {
  title: string;
  onClose: () => void;
  /** Omit both to hide the fullscreen toggle entirely (the portal drawer). */
  isFullscreen?: boolean;
  onToggleFullscreen?: () => void;
}

export function Header({ title, onClose, isFullscreen, onToggleFullscreen }: HeaderProps) {
  return (
    <div class="aj-drawer__header">
      <div class="aj-drawer__title">
        <span class="aj-drawer__title-icon">
          <Sparkle />
        </span>
        <span>{title}</span>
      </div>
      <div class="aj-drawer__header-actions">
        {onToggleFullscreen && (
          <button
            type="button"
            class="aj-drawer__icon-btn"
            title={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
            onClick={onToggleFullscreen}
          >
            {isFullscreen ? <CollapseIcon /> : <ExpandIcon />}
          </button>
        )}
        <button type="button" class="aj-drawer__icon-btn" title="Close" onClick={onClose}>
          <CloseIcon />
        </button>
      </div>
    </div>
  );
}
